module.exports = __webpack_public_path__ + "fonts/Open_Sans-300-cyrillic6.e2d8044.woff2";